import { memo } from "react";
import { LuLeaf } from "react-icons/lu";
import { healthBadge } from "../utils/scoreFormatter";

/** "Very Good Choice" / "Good Choice" / "High Protein" pill from the nutrition data. */
function HealthBadge({ nutrition, size = "small" }) {
  const badge = healthBadge(nutrition);
  if (!badge) return null;
  return (
    <span
      className={`ep-health ${size === "large" ? "is-large" : ""}`}
      style={{ color: badge.color, background: badge.background }}
    >
      <LuLeaf aria-hidden="true" fill="currentColor" fillOpacity={0.9} stroke="#fff" />
      {badge.text}
    </span>
  );
}

export default memo(HealthBadge);
